import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getApplicationSettings } from "../store/sagas/selectors";

/**
 * Resolves whether remote control should be enabled.
 * URL query param show_remote_control overrides backend application setting.
 */
export const useRemoteControlEnabled = (): boolean => {
    const applicationSettings = useSelector(getApplicationSettings);

    return useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const showRemoteControlParam = urlParams.get("show_remote_control");

        if (showRemoteControlParam !== null) {
            return showRemoteControlParam.toLowerCase() === "true";
        }

        return applicationSettings?.["remote_control.show"] === "True";
    }, [applicationSettings]);
};
